import "src/application.css"

import 'polyfills'

import 'modulor'

import 'components'
import 'initializers'
import 'lib'
import 'models'
import 'plugins'
import 'shared'

import {} from 'jquery-ujs'

import Turbolinks from 'turbolinks'
Turbolinks.start()

import MutationObserver from 'lib/modulor/mutation_observer'
MutationObserver.start()
